module.exports = __webpack_public_path__ + "img/1-02.8caa4254.png";